"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DevourIQGetItemAvailabilityResponseToJSON = exports.DevourIQGetItemAvailabilityResponseFromJSONTyped = exports.DevourIQGetItemAvailabilityResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
function DevourIQGetItemAvailabilityResponseFromJSON(json) {
    return DevourIQGetItemAvailabilityResponseFromJSONTyped(json, false);
}
exports.DevourIQGetItemAvailabilityResponseFromJSON = DevourIQGetItemAvailabilityResponseFromJSON;
function DevourIQGetItemAvailabilityResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'menuItemUuid': !(0, runtime_1.exists)(json, 'menuItemUuid') ? undefined : json['menuItemUuid'],
        'isAvailable': !(0, runtime_1.exists)(json, 'isAvailable') ? undefined : json['isAvailable'],
    };
}
exports.DevourIQGetItemAvailabilityResponseFromJSONTyped = DevourIQGetItemAvailabilityResponseFromJSONTyped;
function DevourIQGetItemAvailabilityResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'menuItemUuid': value.menuItemUuid,
        'isAvailable': value.isAvailable,
    };
}
exports.DevourIQGetItemAvailabilityResponseToJSON = DevourIQGetItemAvailabilityResponseToJSON;
